<script setup lang="ts">
import type { IMenuItem } from '@backpackr/ids-web'
import logo from '@/assets/svg/logo.svg'

const MENU_HOVER_OPTION = {
  hideDelay: 50,
  showDelay: 100,
}

const { $platformService } = useNuxtApp()
const authStore = useAuthStore()

const {
  show: showMe,
  mouseOut: mouseOutMe,
  mouseOver: mouseOverMe,
} = useMouseHover(MENU_HOVER_OPTION)

const isLogin = computed(() => {
  return authStore.isLogin
})

const menuItems = [
  {
    label: RESOURCE.ARTIST_APPLY_BUTTON_TEXT,
    value: {
      link: URL_MAP.ARTIST,
    },
  },
  {
    label: '로그아웃',
    value: {
      link: URL_MAP.LOGOUT,
    },
  },
]

const handleClickLogo = () => {
  navigateTo(URL_MAP.HOME)
}

const handleClickApply = () => {
  navigateTo(URL_MAP.ARTIST)
}

const handleClickLogout = () => {
  navigateTo(URL_MAP.LOGOUT)
}

const handleClickMyInfoMenu = (item: IMenuItem) => {
  navigateTo(item.value.link, { external: item.value.external || false })
}
</script>

<template>
  <div class="TheHeader">
    <div class="TheHeader__left">
      <img class="TheHeader__leftLogo" :src="logo" @click="handleClickLogo" />
      <p v-if="$platformService.isDesktop" class="TheHeader__leftTitle">
        {{ RESOURCE.SERVICE_NAME }}
      </p>
    </div>
    <div class="TheHeader__right">
      <div v-if="isLogin" class="TheHeader__rightUser">
        <BaseMenus
          v-if="$platformService.isDesktop"
          :model-value="showMe"
          :items="menuItems"
          @mouseout="mouseOutMe"
          @mouseover="mouseOverMe"
          @update:item="handleClickMyInfoMenu"
        >
          <BaseButtonTextSecondary
            :title="authStore.userInfo?.email ?? ''"
            :size="'medium'"
            :icon="authStore.userInfo?.referralCode ? 'check_small_p5' : ''"
          />
        </BaseMenus>
        <BaseButtonTextSecondary
          v-else
          :title="'로그아웃'"
          :size="'medium'"
          @click="handleClickLogout"
        />
      </div>
      <div v-else class="TheHeader__rightLogin">
        <BaseButtonTextSecondary
          :title="RESOURCE.ARTIST_APPLY_BUTTON_TEXT"
          :size="'medium'"
          @click="handleClickApply"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.TheHeader {
  @apply white--background;
  @apply w-full;
  @apply sticky top-0 left-0 z-tab;
  @apply flex justify-between items-center;
  @apply border-b border-[#E1E1E1];

  height: var(--layout-header-height);

  container-type: inline-size;
  container-name: header-container;

  &__left {
    @apply h-full pl-[40px];
    @apply flex items-center;
    @apply min-w-0;

    @container header-container (max-width: 500px) {
      @apply pl-[16px];
    }

    &Logo {
      @apply w-[116px] h-[20px];
      @apply shrink-0;
      @apply cursor-pointer;
    }

    &Title {
      @apply subtitle3_bold_small;
      @apply ml-[8px];
      // 좁은 폭에서 우측 영역과 겹치지 않도록 말줄임 (WP-6336)
      @apply min-w-0 truncate;
    }
  }

  &__right {
    @apply h-full;
    @apply flex items-center justify-end;
    @apply pr-[40px] shrink-0;

    @container header-container (max-width: 500px) {
      @apply pr-[16px];
    }

    &User {
      @apply flex items-center;

      @container header-container (max-width: 500px) {
        @apply flex-col items-center justify-center;
      }
    }
  }
}
</style>
